import { createContext } from "react"

const ContractsContext = createContext();

export default ContractsContext;